import type { GeoBounds, GeocodeResult } from '@/features/geolocation/types/location';
import type { NominatimPlace } from '@/features/geolocation/services/schemas';

/**
 * Nominatim orders its bounding box `[minLat, maxLat, minLon, maxLon]`; leaflet
 * expects `[[minLat, minLon], [maxLat, maxLon]]`.
 */
function toBounds(boundingBox: NominatimPlace['boundingbox']): GeoBounds | null {
  if (!boundingBox) return null;

  const [minLat, maxLat, minLon, maxLon] = boundingBox.map(Number);
  if ([minLat, maxLat, minLon, maxLon].some((value) => !Number.isFinite(value))) return null;

  return [
    [minLat, minLon],
    [maxLat, maxLon],
  ];
}

export function toGeocodeResult(place: NominatimPlace): GeocodeResult | null {
  const latitude = Number(place.lat);
  const longitude = Number(place.lon);
  if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) return null;

  return {
    coordinates: { latitude, longitude },
    bounds: toBounds(place.boundingbox),
    displayName: place.display_name,
    addressType: place.addresstype ?? null,
    placeRank: place.place_rank ?? null,
  };
}
